import api from "@/services/api";
import { DashboardType } from "@/types/dashboard/Dashboard";
class GetDashboard {
  execute = async (
    startDate: String | undefined,
    endDate: String | undefined,
    franchiseId?: string,
    associateId?: string
  ) => {
    const sanitizedAssociateId = associateId?.trim() ? associateId : undefined;
    const sanitizedFranchiseId = franchiseId?.trim() ? franchiseId : undefined;
    const dashboard = await api().get(`dashboard/data`, {
      params: {
        startDate: startDate,
        endDate: endDate,
        franchiseId: sanitizedFranchiseId,
        associateId: sanitizedAssociateId,
      },
    });

    return dashboard.data as DashboardType;
  };
}

export { GetDashboard };
